const formatAddress = (address) => {
    let formatted = ''
    if (address.street) formatted += address.street
    if (address.number) formatted += `, ${address.number}`
    if (address.complement) formatted += `, ${address.complement}`
    if (address.neighborhood) formatted += ` - ${address.neighborhood}`
    if (address.city) formatted += `, ${address.city}`
    if (address.state) formatted += ` - ${address.state}`
    if (address.country) formatted += `, ${address.country}`
    return formatted
}

export default formatAddress;